const { REACT_APP_WEBSOCKET_URL = "" } = process.env;

const WebsocketClient = (token) => new WebSocket(`${REACT_APP_WEBSOCKET_URL}${token}`);

export default WebsocketClient;